import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import isEqual from "lodash/isEqual"
import {
  Context,
  StudyPlanV2ProgressByContentSchema,
  Transitions
} from "../../../types"
import {
  getProgressBySelectedStudyPlanSubjectTransition,
  getProgressByContentTableDataTransition
} from "../../transitionalStates"

export const spv2ProgressByContentState: StateNodeConfig<
  Context,
  StudyPlanV2ProgressByContentSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_progress_by_content_state",
  initial: "loading",
  states: {
    loading: { ...getProgressByContentTableDataTransition },

    get_progress_by_content_progress: {
      ...getProgressBySelectedStudyPlanSubjectTransition
    },

    idle: {
      on: {
        UPDATE_REPORTING_FILTERS_STATE: {
          target: "loading",
          actions: assign<
            Context,
            Extract<Transitions, { type: "UPDATE_REPORTING_FILTERS_STATE" }>
          >((_ctx, evt) => ({
            reportingFiltersState: evt.state
          })),
          cond: (ctx, evt) => !isEqual(ctx.reportingFiltersState, evt.state)
        }
      }
    }
  }
}
